import React__default, { useEffect } from 'react';
import { c as clsx } from '../clsx.m-7e9a4a81.js';
import { I as Icon } from '../Utilities-be7a8052.js';
import { useEventCallback, Portal } from '@thimble/utility';
import '@babel/runtime-corejs3/helpers/typeof';
import '@babel/runtime-corejs3/core-js-stable/array/is-array';
import '@babel/runtime-corejs3/core-js-stable/object/keys';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import '@babel/runtime-corejs3/core-js-stable/instance/filter';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import '@babel/runtime-corejs3/core-js-stable/object/define-property';
import '@babel/runtime-corejs3/helpers/extends';
import '@babel/runtime-corejs3/helpers/defineProperty';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';

var noop = function noop() {};

var BaseModal = function BaseModal(_ref) {
  var visible = _ref.visible,
      onClose = _ref.onClose,
      _ref$onVisibilityChan = _ref.onVisibilityChange,
      _onVisibilityChange = _ref$onVisibilityChan === void 0 ? noop : _ref$onVisibilityChan,
      children = _ref.children;

  var onVisibilityChange = useEventCallback(_onVisibilityChange);
  useEffect(function () {
    onVisibilityChange(visible);
  }, [visible, onVisibilityChange]);
  return visible ? /*#__PURE__*/React__default.createElement(Portal, null, /*#__PURE__*/React__default.createElement("div", {
    className: "smb-modal-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "smb-modal-mask",
    onClick: onClose
  }), children)) : null;
};

var Modal = function Modal(_ref) {
  var visible = _ref.visible,
      onClose = _ref.onClose,
      onVisibilityChange = _ref.onVisibilityChange,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement(BaseModal, {
    visible: visible,
    onClose: onClose,
    onVisibilityChange: onVisibilityChange
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx('smb-modal')
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "Close",
    color: "dark-green",
    size: "small",
    className: "smb-modal__close",
    onClick: onClose,
    tabIndex: 0
  }), children));
};

var ModalFooter = function ModalFooter(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: 40
    }
  }, children);
};

Modal.Footer = ModalFooter;
Modal.BaseModal = BaseModal;

export default Modal;
